import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";

class MemberGetMemberModalComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.modal = new GenericModalComponent(this.element);
        this.acceptButton = this.element.querySelector('.primary-button');
        this.refuseButton = this.element.querySelector('.secondary-button');
        this.closeButton = this.element.querySelector('.generic-modal__close');
        this.init();
    }


    checkModalVisibility(info) {
        if (this.isSubcribed === 'true') return;
        let url = `/api/1.0/loyalty/campaign/dlover2025/mission/mgm-referral-recipient/start`;

        youserxp.ajax(url, {
            method: 'POST',
            auth: true
        }, {}, "json").then((data) => {
            // if (data.body.ERROR) document.dispatchEvent(new CustomEvent("show-on-boarding-invitation", {detail: null}));
            if (data.body.ERROR) return;
            this.modal.openModal();
        }, () => {});
    }


    completeMission() {
        this.element.querySelector('.generic-modal__error-label')?.remove();
        const input = this.element.querySelector('#friendCode');
        input.value ? input.classList.remove('yxp-error') : input.classList.add('yxp-error');
        if (!input.value) return;

        this.element.classList.add('loading');
        let url = `/api/1.0/site/mydonnad/campaign/dlover2025/mgm/${input.value}/complete`;

        youserxp.ajax(url, {
            method: 'POST',
            auth: true
        }, {}, "json").then((obj) => {
            this.appendResult(obj.body);

            this.element.classList.remove('loading');
        }, () => {
            this.appendError();
            this.element.classList.remove('loading');
        });
    }


    appendError() {
        const html = `<div class="generic-modal__error-label">Errore nel caricamento codice</div>`;
        this.element.querySelector('.generic-modal__card').insertAdjacentHTML('beforeend', html);
    }

    appendResult(data) {
        const bodyWrapper = this.element.querySelector('.generic-modal__card');
        bodyWrapper.innerHTML = `
        <div class="generic-modal__title">Fai parte di DLovers!</div>
         <img class="generic-modal__img" src="/fe-web/img/mydonnad/referAfriendModal.png">
        <div class="generic-modal__description">
            Per darti il benvenuto, abbiamo un regalo per te! <br>
        </div>
        <div class="image-text-bg-wrapper">
            <div class="image-text-bg">         
                <div class="text-small"><b>Bonus benvenuto</b></div>
                <div class="icon ">
                    <div class="chips-points">
                        <span class="chips-points__content">
                            <p><b>+10</b> Punti Cuore</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="image-text-bg single">         
                <div class="text-small"><b>Bonus codice amico</b></div>
                <div class="icon ">
                    <div class="chips-points">
                        <span class="chips-points__content">
                           <p> <b>+4</b> Punti Cuore</p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="generic-modal__cta-wrapper">
            <div class="primary-button">
                <a href="javascript:void(0)">Avanti</a>
            </div>           
        </div>
            `;

        bodyWrapper.querySelector('.primary-button').addEventListener('click', () => {
            this.modal.closeModal();
            document.dispatchEvent(new CustomEvent("show-on-boarding-invitation"));
        });
    }

    thankyouModal() {
        const bodyWrapper = this.element.querySelector('.generic-modal__card');
        bodyWrapper.innerHTML = `
            <div class="generic-modal__title">Fai parte di DLovers!</div>
            <img class="generic-modal__img" src="/fe-web/img/mydonnad/referAfriendModal.png">
            <div class="generic-modal__description">
                Per darti il benvenuto, abbiamo un regalo per te! <br>
            </div>
            <div class="image-text-bg-wrapper">
                <div class="image-text-bg single">         
                    <div class="text-small"><b>Bonus benvenuto</b></div>
                    <div class="icon ">
                        <div class="chips-points">
                            <span class="chips-points__content">
                                <p><b>+10</b> Punti Cuore</p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="generic-modal__cta-wrapper">
                <div class="primary-button">
                    <a href="javascript:void(0)">Avanti</a>
                </div>           
            </div>
            `;

        bodyWrapper.querySelector('.primary-button').addEventListener('click', () => {
            this.modal.closeModal();
            document.dispatchEvent(new CustomEvent("show-on-boarding-invitation"));
        });
    }

    init() {
        this.acceptButton.addEventListener('click', () => this.completeMission());
        this.refuseButton.addEventListener('click', () => this.thankyouModal());
        this.closeButton.addEventListener('click', () => this.thankyouModal());

        this.checkModalVisibility()

    }
}

export default MemberGetMemberModalComponent;
